var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                _c(
                  _setup.MapControlButton,
                  {
                    attrs: {
                      tooltip: _setup.$map.trans("map.setting-control.title"),
                    },
                    on: { click: _setup.onToggleShow },
                  },
                  [
                    _c(_setup.SvgIcon, {
                      attrs: { size: 18, type: "mdi", path: _setup.mdiCog },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "draggable",
            fn: function (props) {
              return [
                _setup.show
                  ? _c(
                      _setup.DraggablePopup,
                      _vm._b(
                        {
                          attrs: {
                            height: 400,
                            width: 400,
                            show: _setup.show,
                            title: _setup.$map.trans(
                              "map.setting-control.title"
                            ),
                          },
                          on: {
                            "update:show": function ($event) {
                              _setup.show = $event
                            },
                          },
                        },
                        "DraggablePopup",
                        props,
                        false
                      ),
                      [
                        _c(
                          "div",
                          { staticClass: "setting-container" },
                          [
                            _c(
                              "div",
                              { staticClass: "setting-field-container" },
                              [
                                _c("div", [
                                  _c("label", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _setup.$map.trans(
                                            "map.setting-control.field.center"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "setting-center-container" },
                                    [
                                      _c(_setup.inputText, {
                                        attrs: {
                                          type: "number",
                                          step: "0.0000001",
                                        },
                                        model: {
                                          value: _setup.setting.center[0],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _setup.setting.center,
                                              0,
                                              $$v
                                            )
                                          },
                                          expression: "setting.center[0]",
                                        },
                                      }),
                                      _c(_setup.inputText, {
                                        attrs: {
                                          type: "number",
                                          step: "0.0000001",
                                        },
                                        model: {
                                          value: _setup.setting.center[1],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _setup.setting.center,
                                              1,
                                              $$v
                                            )
                                          },
                                          expression: "setting.center[1]",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "div",
                                  [
                                    _c(_setup.inputText, {
                                      attrs: {
                                        label: _setup.$map.trans(
                                          "map.setting-control.field.zoom"
                                        ),
                                      },
                                      model: {
                                        value: _setup.setting.zoom,
                                        callback: function ($$v) {
                                          _vm.$set(_setup.setting, "zoom", $$v)
                                        },
                                        expression: "setting.zoom",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(_setup.inputText, {
                                      attrs: {
                                        label: _setup.$map.trans(
                                          "map.setting-control.field.sprite"
                                        ),
                                      },
                                      model: {
                                        value: _setup.setting.sprite,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _setup.setting,
                                            "sprite",
                                            $$v
                                          )
                                        },
                                        expression: "setting.sprite",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(_setup.inputText, {
                                      attrs: {
                                        label: _setup.$map.trans(
                                          "map.setting-control.field.glyphs"
                                        ),
                                      },
                                      model: {
                                        value: _setup.setting.glyphs,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _setup.setting,
                                            "glyphs",
                                            $$v
                                          )
                                        },
                                        expression: "setting.glyphs",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              _setup.baseButton,
                              {
                                staticClass: "btn-container",
                                on: {
                                  click: function ($event) {
                                    return _setup.onSetSetting()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _setup.$map.trans(
                                        "map.setting-control.btn.apply"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }